import { useQueryParams } from './use-query-params';
import { useUpdateQueryParams } from './use-update-query-params';

type setNewValue = (newValue: string, replaceHistory?: boolean) => void;
type deleteValue = (replaceHistory?: boolean) => void;
export function useQueryParamState(
  name: string,
  defaultValue: string,
  initParam: boolean,
): [string, setNewValue, deleteValue];
export function useQueryParamState(
  name: string,
  defaultValue: string,
): [string, setNewValue, deleteValue];
export function useQueryParamState(name: string): [string | undefined, setNewValue, deleteValue];
export function useQueryParamState(
  name: string,
  defaultValue?: string,
  initParam = false,
): [string | undefined, setNewValue, deleteValue] {
  const params = useQueryParams();
  const update = useUpdateQueryParams();
  let currentValue = defaultValue;
  if (params.has(name)) {
    currentValue = (params.get(name) as string).trim();
  } else if (initParam) {
    params.set(name, currentValue || '');
    update(params, { replace: true });
  }
  const setNewValue: setNewValue = (newValue: string, replaceHistory = true) => {
    params.set(name, newValue);
    update(params, { replace: replaceHistory });
  };
  const deleteValue: deleteValue = (replaceHistory = true) => {
    params.delete(name);
    update(params, { replace: replaceHistory });
  };
  return [currentValue, setNewValue, deleteValue];
}
